import React, { useState } from "react";
import UploadElementDialog from "./UploadElementDialog";
import { AppButton } from "../ui";
import useElementUploadWorkflow from "./useElementUploadWorkflow";

const NewElementUploader = ({ onNewElementCreated, initialElementId, initialElementData }) => {
  const [uploadDialogOpen, setUploadDialogOpen] = useState(false);
  const { uploadSingleElement } = useElementUploadWorkflow({
    initialElementId,
    initialElementData,
  });

  const handleOpenDialog = () => {
    setUploadDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setUploadDialogOpen(false);
  };

  const handleUpload = async ({ name, description, file, optimization }) => {
    if (!file) {
      return;
    }

    try {
      const createdElement = await uploadSingleElement({
        file,
        name,
        description,
        optimization,
      });

      // Call parent's callback, if provided, to update the list.
      if (onNewElementCreated && !initialElementId) {
        onNewElementCreated(createdElement);
      }

      handleCloseDialog();
    } catch (error) {
      console.error("Error uploading new element:", error);
      throw error;
    }
  };

  return (
    <>
      <AppButton onClick={handleOpenDialog}>
        Upload New Element
      </AppButton>
      <UploadElementDialog
        open={uploadDialogOpen}
        onClose={handleCloseDialog}
        onUpload={handleUpload}
      />
    </>
  );
};

export default NewElementUploader;
